import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from '@app/services/app.service';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  defaultHeaders: HttpHeaders;

  constructor(
    private http: HttpClient,
    private router: Router,
    private app: AppService
  ) {
    if (!environment.apiUrl) {
      environment.apiUrl = window.location.origin;
    }
    this.defaultHeaders = new HttpHeaders({
      'content-type': 'application/json',
    });
  }

  get(url: string, queryParams?: any): Observable<any> {
    const headers = localStorage.getItem('qualitybidders.token') ? this.getAuthHeaders() : this.defaultHeaders;
    return this.http.get(environment.apiUrl + url, { params: queryParams, headers });
  }

  private getAuthHeaders(): HttpHeaders {
    return new HttpHeaders({
      'content-type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('qualitybidders.token'),
    });
  }
}
